<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import Router from "./router/Routes";
import VueResource from "vue-resource";
import { Toast } from "mint-ui";
Vue.http.options.emulateJSON = true;
Vue.http.interceptors.push(function() {
  return function(response) {
    if (!response.ok) {
      Toast("连接服务器失败，请稍后重试！");
    } else if (response.body.code == 100) {
      //Toast("您已离线，请重新登录！");
      Router.push("/login");
    }
  };
});

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userData: null,
    proData: [],
    dealerData: []
  },
  mutations: {
    setUserData (state, data) {
      state.userData = data;
    },
    setProdData(state, data){
      state.proData = data;
    },
    setDealerData(state, data){
      state.dealerData = data;
    }
  },
  actions: {
    loadProdData(context){
      Vue.http.get(Vue.prototype.GLOBAL.serverUrl + "/ent/prod").then(function(resp) {
        if (resp.body.code == 200) {
          context.commit("setProdData", resp.body.data);
        } else if (resp.body.code == 500) {
          Toast("获取数据失败，请稍后再试！");
        }
      });
    },
    loadDealerData(context){
      Vue.http.get(Vue.prototype.GLOBAL.serverUrl + "/ent/dealer").then(function(resp) {
        if (resp.body.code == 200) {
          context.commit("setDealerData", resp.body.data);
        } else if (resp.body.code == 500) {
          Toast("获取数据失败，请稍后再试！");
        }
      });
    }
  }
});

export default {
  name: "app",
  router: Router,
  store
};
</script>

<style>
body {
  padding: 0;
  margin: 0;
}
.mint-cell-wrapper {
  background-position: bottom left !important;
  padding: 10px !important;
  box-sizing: border-box !important;
  background-origin: border-box;
}
.mint-tab-item-icon{
  width:20px!important;
  height:20px!important;
}

.mint-field.required .mint-cell-title .mint-cell-text::after {
    content: "*";
    color: red;
    vertical-align: middle;
}
</style>